const pct = (x) => `${Math.round(x * 100)}%`;
const BASIS = { consensus: "consensus, margin removed", normalised: "all prices, margin removed", raw: "raw, 100 ÷ odds" };
const VERDICT = { value: ["Value", "text-emerald-300"], fair: ["Fair price", "text-slate-300"], under: ["Under the odds", "text-rose-300"] };

export const oddsText = (s) => (s?.odds ? `$${Number(s.odds).toFixed(2)}${s.odds_source ? ` (${s.odds_source})` : ""}` : null);

export const pts = (e) => `${e > 0 ? "+" : ""}${(Math.round(e * 1000) / 10).toFixed(1).replace(/\.0$/, "")} pts`;

export const ValueAssessment = ({ s, testid }) => {
  const v = s.verdict || (s.edge == null ? null : s.edge >= 0.02 ? "value" : s.edge <= -0.02 ? "under" : "fair");
  const [label, tone] = VERDICT[v] || [];
  return (
    <p className="text-xs text-slate-300 flex flex-wrap gap-x-3 gap-y-0.5" data-testid={testid}>
      <span><span className="text-slate-500">Price </span><span className="font-mono text-amber-300">{oddsText(s) || "no market price"}</span></span>
      <span data-testid={`${testid}-est`}><span className="text-slate-500">Estimated win chance </span>{s.est_win_prob != null ? <span className="font-mono">{pct(s.est_win_prob)}</span> : "not given"}</span>
      {s.market_prob != null
        ? <span data-testid={`${testid}-market`}><span className="text-slate-500">Market-implied chance </span><span className="font-mono">{pct(s.market_prob)}</span><span className="text-slate-500"> ({BASIS[s.market_basis] || "market"})</span></span>
        : <span className="text-amber-300" data-testid={`${testid}-market`}>Market probability unavailable</span>}
      {s.edge != null && <span data-testid={`${testid}-edge`}><span className="text-slate-500">Estimated value difference </span><span className={`font-mono ${tone}`}>{pts(s.edge)}</span> <span className={`font-semibold ${tone}`}>{label}</span></span>}
    </p>
  );
};

export const RoughieDetail = ({ s, testid }) => (
  <div className="mt-1 space-y-0.5 text-xs" data-testid={testid}>
    <ValueAssessment s={s} testid={`${testid}-value`} />
    {s.value_reason && <p className="text-slate-300"><span className="text-slate-500">{s.role === "roughie" || !s.role ? "Why value: " : "Value view: "}</span>{s.value_reason}</p>}
    {s.main_risk && <p className="text-slate-300"><span className="text-slate-500">Main risk: </span>{s.main_risk}</p>}
  </div>
);

export const roughieNote = (s) => {
  const cut = (t, n) => (t && t.length > n ? `${t.slice(0, t.lastIndexOf(" ", n - 1) > 0 ? t.lastIndexOf(" ", n - 1) : n - 1).replace(/[\s,;:(—-]+$/, "")}…` : t);
  const sentence = (s.reason || "").split(/(?<=\.)\s/)[0];
  return [cut(sentence, 200), oddsText(s) && `Price ${oddsText(s)}.`, s.value_reason && `Value: ${cut(s.value_reason, 160)}`, s.main_risk && `Risk: ${cut(s.main_risk, 110)}`]
    .filter(Boolean).join(" ").slice(0, 500);
};
